import { h, Component } from 'preact';
import { Icon } from '@cube/blocks';
import Current from '../current';
import style from './style';
import cx from 'classnames';
import { trackingProvider, DIMENSION } from '@cube/track';
import getAlertColor from '../../lib/alert-color.js';

@trackingProvider({
	[DIMENSION.componentpath]: 'WeatherCompact'
})
export default class WeatherCompact extends Component {

	render({ conditions, currentUnit, config, location, changeUnit, weatherLink, alerts, showAlerts, displayMode }) {

		return (
			<div key="container" class={cx(style.container, style.compact)}>
				<a href={weatherLink} target="_blank" rel="noopener noreferrer">
					<Current
						today={conditions}
						unit={currentUnit}
						changeUnit={changeUnit}
						displayMode={displayMode}
					/>
					<div class={style.weatherMiddle}>
						<div class={style.weatherLocWrap}>
							{location.name}
						</div>
						<div class={style.weatherConditions}>
							{conditions.conditionDescription}
						</div>
					</div>
					<div class={style.compactAlert}>
						{alerts && showAlerts &&
							<Icon name="alert-cube" class={style[getAlertColor(alerts)]} />
						}
					</div>
					<div class={style.circle}>
						<Icon name="navigate-right-cube" class={style.circleIcon} />
					</div>
				</a>
			</div>
		);
	}
}
